import { useMemo } from 'react';
import { useUserInfo } from 'marketing-platform-lib/providers/UserInfoProvider';
import useFetch from 'framework-asset-preview-lib/internal/shared/hooks/useFetch';
import { fetchStatisticsForObjectType } from '../api';
export default function useFetchAssetPerformance(crmObject, nonCrmObject) {
  const {
    hasScope
  } = useUserInfo();
  const useFetchProps = useMemo(() => ({
    fetcher: () => fetchStatisticsForObjectType({
      crmObject,
      nonCrmObject,
      options: {
        hasScope
      }
    })
  }), [crmObject, hasScope, nonCrmObject]);
  return useFetch(useFetchProps);
}